// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"de44d526","210":"8f590c74","279":"fe38beab","332":"40fe7175","353":"5fc56a28","661":"527a189b","937":"e96da08b"}[chunkId] + ".chunk.js";
};